<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <div style="position: relative">
          <loading-overlay :loading="loading" />
          <div>
            <div class="d-flex justify-content-between">
              <h2>
                <feather-icon icon="BarChart2Icon" size="23" /> الإحصائيات
              </h2>
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'C' }"
                variant="success"
                @click="activModel = true"
              >
                <feather-icon icon="PlusIcon" /> إضافة</b-button
              >
            </div>
            <hr />
          </div>
          <b-list-group>
            <b-list-group-item>
              <b-row>
                <b-col cols="5">
                  <h3>العنوان</h3>
                </b-col>
                <b-col cols="3">
                  <h3>العدد</h3>
                </b-col>
                <b-col cols="2"> <h3>الأيقونة</h3> </b-col>
                <b-col cols="2"> </b-col>
              </b-row>
            </b-list-group-item>
            <card-statistics
              v-can="{ slug: $route.meta.slug, action: 'S' }"
              v-for="(item, i) in statistics"
              :key="i"
              :item="item"
            ></card-statistics>
            <div>
              <alert
                massage="عذراً لا يوجد نتائج لعرضها"
                class="w-100"
                v-if="statistics.length == 0 && !loading"
              ></alert>
            </div>
          </b-list-group>
          <modal-statistics v-model="activModel" type="ADD"> </modal-statistics>
        </div>
      </b-card>
    </b-col>
    <!-- <b-col cols="3">
      <b-card to="docs">
        <h3>
          <feather-icon
            icon="HelpCircleIcon"
            size="25"
            style="margin: 0px 8px"
          />
          إرشادات
        </h3>
        <hr />
        <div>
          <ul>
            <li></li>
          </ul>
        </div>
      </b-card>
    </b-col> -->
  </b-row>
</template>
<script>
import {
  BCard,
  BListGroup,
  BListGroupItem,
  BButton,
  BRow,
  BCol,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import CardStatistics from "../../components/CardStatistics.vue";
import ModalStatistics from "../../components/ModalStatistics.vue";
import Alert from "@/components/Alert.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";

export default {
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    BButton,
    BRow,
    BCol,
    ModalStatistics,
    CardStatistics,
    Alert,
    LoadingOverlay,
  },
  data: () => {
    return {
      activModel: false,
      info: {},
    };
  },
  computed: {
    ...mapGetters("manageInterfaceNgo/statistics", ["statistics", "loading"]),
  },
  created() {
    this.$store.dispatch("manageInterfaceNgo/statistics/getStatistics");
  },
};
</script>
